export const isDevelopment = () => process.env.FLAGXS_ENV === 'development'
export const isStaging = () => process.env.FLAGXS_ENV === 'staging'
export const isProduction = () => process.env.FLAGXS_ENV === 'production'
